import $ from "jquery";
import toastr from "toastr";

const handleNotifyRequest = function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $notifyButton = $(e.target);
  const targetUrl = $notifyButton.attr("href");
  const menuItemId = $notifyButton.data("menu-item-id");
  $.post(targetUrl, { menu_item_id: menuItemId }, (data) => {
    toastr.success(data.message, "", {
      "positionClass": "toast-top-center",
      "timeOut": 4000
    });
  }).fail((err) => {
    toastr.error(err.message, "", {
      "positionClass": "toast-top-center",
      "timeOut": 4000
    });
  });
};

$(document).on("turbolinks:load", () => {
  $("a.notify-request").on("click", handleNotifyRequest);
});
